"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Layer = _interopRequireDefault(require("./Layer"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
/* eslint-disable spaced-comment */
///<reference path="../../../../../../node_modules/@types/leaflet/index.d.ts" />
/* eslint-enable spaced-comment */

class LeafletPolylineLayer extends _Layer.default {
  constructor(layer, points) {
    let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    super(layer, opts, id);
    this._points = points;
  }
  setOpacity(value) {
    super.setOpacity(value);
    if (this.renderable) {
      this.renderable.setStyle(Object.assign(Object.assign({}, this.opts), {
        opacity: value
      }));
    }
  }
  addToMap(map, index) {
    this.renderable.off();
    this.renderable.on('click', () => this.trigger('click', {
      data: this.data,
      shape: this.renderable
    }));
    this.renderable.on('mouseover', () => this.trigger('mouseover', {
      data: this.data,
      shape: this.renderable
    }));
    this.renderable.on('mouseout', () => this.trigger('mouseout', {
      data: this.data,
      shape: this.renderable
    }));
    super.addToMap(map, index);
  }
  removeFromMap(map) {
    this.renderable.off();
    this.renderable.remove();
  }
  createRenderable() {
    return L.polyline(this._points, Object.assign(Object.assign({}, this.opts), {
      opacity: this.opacity
    }));
  }
}
var _default = exports.default = LeafletPolylineLayer;
module.exports = exports.default;